import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router';
import LoginForm from '../components/login/LoginForm';
import BasicLayout from '../layouts/BasicLayout';

function Home() {
  const [itemId, setItemId] = useState('');
  const [itemDetails, setItemDetails] = useState(null);
  const [itemError, setItemError] = useState(null);
  // const navigate = useNavigate();

  useEffect(() => {
    console.log("REFRESH HOME");
  }, []);

  console.log("base level home");

  const handleItemIdChange = (e) => setItemId(e.target.value);

  const handleFetchItem = async (e) => {
    e.preventDefault();
    setItemError(null);
    setItemDetails(null);
    if (!itemId) return;
    try {
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/item/${itemId}`);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/item/${itemId}`);
      if (!response.ok) throw new Error('Item not found');
      const data = await response.json();
      setItemDetails(data);
      // navigate(`/api/item/${itemId}`);
    } catch (err) {
      setItemError(err.message || 'Failed to fetch item');
    }
  };

  return (
    <BasicLayout>
      <div>
        <form onSubmit={handleFetchItem} style={{ marginTop: 30 }}>
          <input
            type="text"
            placeholder="Enter Item ID"
            value={itemId}
            onChange={handleItemIdChange}
            style={{ padding: '8px', fontSize: '1em', marginRight: '10px' }}
          />
          <button type="submit" style={{ padding: '8px 16px', fontSize: '1em' }}>Fetch Item</button>
        </form>
        {itemError && <div style={{ color: 'salmon', marginTop: 10 }}>{itemError}</div>}
        <p>Example Item ID: 256631546717</p>
        {itemDetails && (
          <div style={{ marginTop: 20, textAlign: 'left', background: '#222', padding: 16, borderRadius: 8 }}>
            <h3>Item Details</h3>
            <pre style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>{JSON.stringify(itemDetails, null, 2)}</pre>
          </div>
        )}
        <LoginForm />
      </div>
    </BasicLayout>
  );
}

export default Home;
